import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'

import { MODAL_ALERT_TYPES } from 'utils/consts'
import ModalAddControllersToGroups from './ModalAddControllersToGroups'
import actions from 'store/actions'

import closeBtn from 'assets/images/close.svg'
import removeBtn from 'assets/images/remove.svg'

class ModalCardController extends React.Component {
  state = {
    isOpenModalAddControllersToGroups: false,
  }

  /**
   * @param {Object} group
   */
  removeGroup = async group => {
    const data = {
      employee_id: [],
      access_object_id: this.props.controller.id,
      group_id: group.id,
    }

    try {
      await this.props.removeGroup(data)
      await this.props.fetchControllers({
        count: this.props.itemsPerPage,
        page: this.props.pageNumber,
      })
    } catch (error) {
      this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  changeVisibillityModalAddControllersToGroups = () => {
    this.setState(prevState => ({
      isOpenModalAddControllersToGroups: !prevState.isOpenModalAddControllersToGroups,
    }))
  }

  render() {
    const { controller, itemsPerPage, pageNumber } = this.props
    const { isOpenModalAddControllersToGroups } = this.state

    return (
      <>
        <div className='modal-overlay'>
          <div className='modal modal--sm'>
            <div className='modal__header'>
              <p className='modal__title'>Карточка точки доступа</p>
              <Button
                className='button--icon'
                icon={true}
                iconPicture={closeBtn}
                action={this.props.closeModal}
              />
            </div>

            <div className='modal__content'>
              {!!controller.groups.length ? (
                <div className='groups-list groups-list--fixed overflow-list'>
                  {controller.groups.map(group => (
                    <div className='groups-list__group' key={group.id}>
                      <div>
                        <div className='group-name'>{group.title}</div>
                        <div className='group-controllers'>
                          Кол-во участников: {group.users.length}
                        </div>
                      </div>
                      <Button
                        className='btn--icon'
                        icon={true}
                        iconPicture={removeBtn}
                        action={() => this.removeGroup(group)}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className='not-exist not-exist--modal'>
                  Точка доступа не назначена ни в одну группу.
                </div>
              )}
            </div>

            <div className='modal__bottom'>
              <Button
                title='Добавить в группу'
                className='btn--lg btn--link btn--padding-lr0'
                action={this.changeVisibillityModalAddControllersToGroups}
              />
            </div>
          </div>
        </div>
        {isOpenModalAddControllersToGroups && (
          <ModalAddControllersToGroups
            selectedControllers={[controller.id]}
            itemsPerPage={itemsPerPage}
            pageNumber={pageNumber}
            closeModal={this.changeVisibillityModalAddControllersToGroups}
          />
        )}
      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    removeGroup: data => dispatch(actions.groups.removeGroup(data)),
    fetchControllers: data => dispatch(actions.controllers.fetchControllers(data)),
  }
}

export default connect(null, mapDispatchToProps)(ModalCardController)
